import React, { useCallback, useContext, useMemo, useReducer } from 'react';

const DuplicateDashboardContext = React.createContext();

export const DUPLICATE_SP = 'DUPLICATE_SP';
export const DUPLICATE_GROUP = 'DUPLICATE_GROUP';
export const DUPLICATE_NAME = 'DUPLICATE_NAME';

const DuplicateDashboardReducer = (state, action) => {
    switch (action.type) {
        case DUPLICATE_SP: {
            return {
                ...state,
                social_profiles: { ...state.social_profiles, ...action.payload }
            };
        }
        case DUPLICATE_GROUP: {
            return {
                ...state,
                groups: { ...state.groups, ...action.payload }
            };
        }
        case DUPLICATE_NAME: {
            return {
                ...state,
                ...action.payload
            };
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
};

const DuplicateDashboardProvider = ({ defaultValues, ...restProps }) => {
    const [state, dispatch] = useReducer(DuplicateDashboardReducer, {
        ...defaultValues
    });
    const dispatchDuplicateDashboard = useCallback((...args) => dispatch(...args), [dispatch]);
    const duplicateDashboardData = useMemo(() => state, [state]);
    return (
        <DuplicateDashboardContext.Provider
            value={{ duplicateDashboardData, dispatch: dispatchDuplicateDashboard }}
            {...restProps}
        />
    );
};

const useDuplicateDashboard = () => {
    const context = useContext(DuplicateDashboardContext);
    if (!context) {
        throw new Error('useDuplicateDashboard must be used within a GlobalInfoProvider');
    }
    return context;
};

export { DuplicateDashboardProvider, useDuplicateDashboard };
